import { useNavigate } from 'react-router-dom';
import { useWishlist } from '../context/WishlistContext';

export default function HeartButton({ productId, className = '' }) {
  const navigate = useNavigate();
  const { inWishlist, toggle } = useWishlist();
  const active = inWishlist(productId);

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const ok = await toggle(productId);
    if (!ok) navigate('/login');
  };

  return (
    <button
      className={`heart-btn ${active ? 'active' : ''} ${className}`}
      onClick={onClick}
      aria-label={active ? 'Remove from wishlist' : 'Add to wishlist'}
      title={active ? 'Remove from wishlist' : 'Add to wishlist'}
    >
      <i className={`${active ? 'fas' : 'far'} fa-heart`} />
    </button>
  );
}
